import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/Agency`;



const ApiAgency = {
  getAllAgency: (params) => {
    const url = `${baseServiceUrl}/getAllAgency`;
    return ServiceApi.get(url, { params });
  },
  getAllAgencies: (params) => {
    const url = `${baseServiceUrl}/getAllAgencies`;
    return ServiceApi.get(url);
  },
  getAgencyById: (params) => {
    const url = `${baseServiceUrl}/getAgencyById?id=` + params;
    return ServiceApi.get(url, params);
  },
  getEnumType: () => {
    const url = `${baseServiceUrl}/getAgencyType`;
    return ServiceApi.get(url);
  },
  createAgency: (params) => {
    const url = `${baseServiceUrl}/createAgency`;
    return ServiceApi.post(url, params);
  },
  updateAgency: (params) => {
    const url = `${baseServiceUrl}/updateAgency`;
    return ServiceApi.put(url, params);
  },
  getAgencyTransaction: (params) => {
    const url = `${baseServiceUrl}/getAgencyTransaction`;
    return ServiceApi.get(url, { params });
  },

};

export default ApiAgency;


